// The anonymous owner key every edge API call carries as X-Device-Id: a
// client-generated UUID v4, persisted in localStorage. Not an account --
// PRD 4.7's passkeys/Sign in with Apple/Google are a later ticket; this is
// the interim shape "anonymous local use allowed until sync is wanted"
// describes, and every edge route (apps/edge/src/device.ts) already keys
// on exactly this string, so swapping in real auth later needs no schema
// change, only a different way to obtain the id.
const STORAGE_KEY = "proef.deviceId";

let cached: string | undefined;

export function getDeviceId(): string {
  if (cached !== undefined) return cached;
  try {
    const stored = window.localStorage.getItem(STORAGE_KEY);
    if (stored !== null) {
      cached = stored;
      return stored;
    }
  } catch {
    // Storage blocked (private mode): fall through to a session-only id.
  }
  const id = crypto.randomUUID();
  try {
    window.localStorage.setItem(STORAGE_KEY, id);
  } catch {
    // Nothing persists this session, but every call still carries a
    // consistent id for its own lifetime.
  }
  cached = id;
  return id;
}
